import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseMutateResource } from '../../utils/types';

type DeleteLineItemFunction = MutateFunction<TrpcInputs['deleteLineItem'], TrpcOutputs['deleteLineItem']>;
type UseDeleteLineItem = UseMutateResource<DeleteLineItemFunction>;

export const useDeleteLineItem = (id: number): UseDeleteLineItem => {
  const { mutateAsync, isLoading, error } = trpc.deleteLineItem.useMutation();
  const handleDelete: DeleteLineItemFunction = () => mutateAsync({ id } as any);

  return [handleDelete, isLoading, error?.message];
};
